import React from "react";
import MenuNavbar from "../function-components/MenuNavbar";
import Floaticons from "../function-components/Floaticons";
import "./Hackathon.css";

import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs"; 

function Hackathon() {
    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />

                <div className="breadcrumbs-container">
                    <Breadcrumbs separator=">" sx={{ color: "#fff" }}>
                        <Link
                            underline="hover"
                            sx={{ display: "flex", alignItems: "center", color: "#fff" }}
                            href="/"
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        </Link>

                        <Link underline="hover" sx={{ color: "#fff" }} href="/KeyInitiatives">
                            Key Initiatives
                        </Link>

                        <Typography sx={{ color: "#fff" }}>Hackathon</Typography>
                    </Breadcrumbs>
                </div>

                <MenuNavbar />
            </div>

            <Floaticons />

            <div className="hackathon-wrapper">
                <p className="hackathon-top-text">
                    A progressive, AI-first cybersecurity hackathon that builds job-ready offensive and defensive skills
                    through structured assessment, hands-on challenges, and real-world simulations.
                </p>


                <div className="hackathon-body">
                    {/* LEFT CONTENT */}
                    <div className="hackathon-left">
                        <div className="hackathon-icon-strip">
                            <div className="icon-strip-box">
                                <img src="images/Hackathon/icon1.svg" className="top-strip-icon" />
                            </div>
                            <div className="icon-strip-box">
                                <img src="images/Hackathon/icon2.svg" className="top-strip-icon" />
                            </div>
                            <div className="icon-strip-box">
                                <img src="images/Hackathon/icon3.svg" className="top-strip-icon" />
                            </div>
                        </div>


                        <div className="hackathon-content-row">
                            <div className="hackathon-col">
                                <h3>Objectives</h3>
                                <ul>
                                    <li>
                                        Build mature, job-ready offensive and defensive cybersecurity capabilities through a progressive,
                                        AI-first hackathon model.
                                    </li>
                                    <li>

                                        Move participants from foundational validation to applied execution and real-world decision-making.
                                    </li>
                                    <li>
                                        Enable fair, scalable, and outcome-driven skill assessment across cohorts.
                                    </li>
                                </ul>
                                <div className="purple-line" />
                            </div>

                            <div className="hackathon-col">
                                <h3>Learning Journey</h3>
                                <ul>
                                    <li>

                                        Participants progress through a three-level offensive and defensive cybersecurity journey—MCQs,
                                        Capture-the-Flag challenges, and live simulations—powered by AI-assisted analysis and decision support.
                                    </li>
                                    <li>
                                        Each level increases in complexity and realism, with AI enhancing attack execution, threat detection,
                                        investigation, and response effectiveness at scale.
                                    </li>
                                </ul>
                                <div className="purple-line" />
                            </div>

                            <div className="hackathon-col">
                                <h3>Outcome</h3>
                                <ul>
                                    <li>
                                        Validated foundational knowledge at scale, applied hands-on skill assessment, and real-life execution capability.
                                    </li>
                                    <li>
                                        Stronger, AI-centric security mindset across offensive and defensive teams.
                                    </li>
                                    <li>
                                        Clear identification of top talent, role readiness, and measurable improvement in security skill maturity
                                        over three progressive levels.

                                    </li>
                                </ul>
                                <div className="purple-line" />
                            </div>
                        </div>

                    </div>


                    <div className="hackathon-target">
                        <img src="images/Hackathon/Target_img.svg" alt="target" />
                    </div>
                </div>
            </div>

            {/* //Program Overview section */}

            <div className="program-overview-container">
                <h3 className="program-head">Program Overview</h3>
                <p>
                    The Hackathon is focused on offensive and defensive AI based on the below tracks
                </p>
                <div className="para-container">
                    <div className="para1">
                        <p>
                            Break the Vault:AI driven Adversaries
                        </p>
                    </div>
                    <div className="para2">
                        <p>
                            Shield the Citadel: Autonomous Defense
                        </p>
                    </div>
                </div>
                <div className="program-img-container">
                    <img src="images/Hackathon/ProgramOverview_img.svg" alt="Program_Levels" className="program-img" />
                </div>
            </div>

            <div className="Executive-Frame-container">
                <h3 className="executive-head">Executive Framework</h3>
                <p className="executive-des">Registration opens on <span className="date">13th May 2026</span></p>

                <div className="exectuive-img-container">
                    <img src="images/Hackathon/ExecutiveFramework_img.svg" alt="Program_Levels" className="executive-img" />
                </div>

                {/* <div className="register-container">
                    <div className="tick_cont">
                        <img src="images/Hackathon/tick_icon.svg" alt="tick_logo" className="tick_icon" />
                        <p>Offensive & Defensive tracks</p>
                    </div>
                    <div className="tick_cont2">
                        <img src="images/Hackathon/tick_icon.svg" alt="tick_logo" className="tick_icon" />
                        <p>Multiple sets ensure fairness and scalability</p>
                    </div>
                    <button className="reg-btn">Register Here</button>
                </div> */}


                <div className="register-container">
                    <div className="register-inner">
                        <div className="features">
                            <div className="tick-item">
                                <img
                                    src="images/Hackathon/tick_icon.svg"
                                    alt="tick"
                                    className="tick_icon"
                                />
                                <p>Offensive & Defensive tracks</p>
                            </div>

                            <div className="tick-item">
                                <img
                                    src="images/Hackathon/tick_icon.svg"
                                    alt="tick"
                                    className="tick_icon"
                                />
                                <p>Multiple sets ensure fairness and scalability</p>
                            </div>
                        </div>

                        <button className="reg-btn">Register Here</button>
                    </div>
                </div>

            </div>
        </>
    );
}

export default Hackathon;